import { I18nMessage, I18nMessageDefinition } from "components/i18n/I18nMessage";
import i18n from "components/i18n/i18n";
import $ from "jquery";
import template from "./confirmationDialog.hbs";

export class ConfirmationDialog {
    public definition: ConfirmationDialogDefinition;
    private dialog: JQuery;
    constructor(definition: ConfirmationDialogDefinition) {
        this.definition = definition;
        this.definition.confirmationAccept = this.definition.confirmationAccept || { key: "dialog.button.accept" };
        this.definition.confirmationDeclineKey = this.definition.confirmationDeclineKey || "dialog.button.decline";
    }

    public open = () => {

        let fnc_cancel = () => {
            if (this.definition.cancelCallback != null) {
                this.definition.cancelCallback();
            }
            this.dialog.dialog("close");
        };
        let fnc_accept = () => {
            this.definition.acceptCallback();
            this.dialog.dialog('close');
        };
        let botonera = [{
            id: "bt-accept",
            text: new I18nMessage(this.definition.confirmationAccept).toString(),
            click: fnc_accept
        }, {
            id: "bt-cancel",
            text: new I18nMessage(this.definition.confirmationDeclineKey).toString(),
            click: fnc_cancel
        }];

        this.dialog = $(template(this.definition)).dialog({
            resizable: false,
            height: "auto",
            width: 400,
            modal: true,
            closeText: i18n.instance.t("base.close.action"),
            buttons: botonera,
            open: function () {
                const indexBtnCancel = 2;
                $(this).parent().find('button:nth-child(' + indexBtnCancel + ')').trigger("focus");
            }
        });
    }

    public close = () => {
        if (this.definition.cancelCallback != null) {
            this.definition.cancelCallback();
        }
        this.dialog.dialog("close");
    }
}

export interface ConfirmationDialogDefinition {
    confirmationMessages: I18nMessageDefinition[];
    confirmationAccept?: I18nMessageDefinition;
    confirmationDeclineKey?: string;
    acceptCallback: () => void;
    cancelCallback?: () => void;
}
